import React, { useCallback, useEffect, useState } from "react";
import { Column } from "primereact/column";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toolbar } from 'primereact/toolbar';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { BlockUI } from "primereact/blockui";
import { Dialog } from "primereact/dialog";
import Preventivo from "../component/Preventivo";
import { useToast } from "../contexts/ToastContext";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import moment from 'moment';
import { Dropdown } from 'primereact/dropdown';

const ListaPreventiviPage = () => {
  const [preventivi, setPreventivi] = useState([]);
  const [password, setPassword] = useState("");
  const [passwordInserita, setPasswordInserita] = useState();
  const { showToast } = useToast();
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tel: { value: null, matchMode: FilterMatchMode.CONTAINS },
    mail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nome: { value: null, matchMode: FilterMatchMode.CONTAINS },
    stato: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    dataInserimento: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
  });
  const [stati] = useState([{ label: 'NUOVO', value: "NUOVO" }, { label: "CONTATTATO", value: "CONTATTATO" }, { label: "IN CORSO", value: "IN CORSO" }, { label: "ANNULLATO", value: "ANNULLATO" }, { label: "CONCLUSO", value: "CONCLUSO" }])

  const [dettPreventivoVisible, setDettPreventivoVisible] = useState(false);
  const [dettPreventivo, setDettPreventivo] = useState();

// LOCASTORAGE 
    useEffect(() => {
     
    if(localStorage?.getItem("chiave"))
      setPasswordInserita(localStorage?.getItem("chiave"))
    }, [localStorage]);

  //aggiornati dall'oggetto preventivo, servono per generare il pdf
  const [preventivo, setPreventivo] = useState()
  const [prevTab, setPrevTab] = useState([])
  const [extraTab, setExtraTab] = useState([])

  useEffect(() => {
    
    if (passwordInserita) {
      fetchData(); // Chiama la funzione per fare la richiesta
      localStorage.setItem("chiave", passwordInserita)
    }
  }, [passwordInserita]);

  const getPreventiviConDate = (data) => {
    return [...(data || [])].map((d) => {
      d.dataInserimento = new Date(d.dataInserimento)
      return d;
    });
  }

  const fetchData = () => {
    setLoading(true);
    axios.get("https://backend.mnediliziaristrutturazione.com/preventivi/", { headers: { "pwd": passwordInserita } }).then()
      .then((response => {
        const result = getPreventiviConDate(response.data)
        //console.log("result", result)
        setPreventivi(result);  // Aggiorna lo stato con i dati ricevuti
        setLoading(false);
      }))
      .catch((error) => {
        setLoading(false);
        showToast({
          severity: "error",
          summary: "Errore",
          detail: "Errore nel recupero dei preventivi",
          life: 3000,
        });
      })
  }

  const handleVerificaPassword = async () => {
    try {
      const response = await axios.post(
        "https://backend.mnediliziaristrutturazione.com/verificapassword",
        { password: password }
      );
      if (response.data.esito === "OK")
        setPasswordInserita(password);
      else {
        showToast({
          severity: "error",
          summary: "Rifiutata",
          detail: "Password non corretta",
          life: 3000,
        });
        setPasswordInserita(false); // Aggiorna lo stato con i dati ricevuti
      }
    } catch (error) {
      alert("la verifica della password non è andata a buon fine");
      //setError(error); // Imposta l'errore in caso di fallimento della richiesta
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleVerificaPassword();
    }
  };

  const loginJsx = (
    <div className="flex">
      <div className="surface-section w-full md:w-6 p-6 md:p-8">
        <div className="mb-5">
          <img
            src="/assets/logo/logo.svg"
            alt="hyper"
            height={50}
            className="mb-3"
          />
          <div className="text-900 text-3xl font-medium mb-3">Benvenuto</div>
        </div>
        <div className="w-full">
          <label
            htmlFor="password2"
            className="block text-900 font-medium mb-2"
          >
            Password
          </label>
          <InputText
            autoFocus
            onKeyDown={handleKeyDown}
            id="password2"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-3"
          />
          <Button
            label="Entra"
            icon="pi pi-user"
            className="w-full mb-3"
            onClick={() => handleVerificaPassword()}
          />
        </div>
      </div>
      <div
        className="hidden md:block w-6 bg-no-repeat bg-cover"
        style={{ backgroundImage: "url('/assets/immagini/signin.jpg')" }}>
      </div>
    </div>
  )

  const renderHeader = () => {
    const value = filters['global'] ? filters['global'].value : '';

    return (
      <>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Ricerca globale" />
        </IconField>
        <Button type="button" icon="pi pi-file-pdf" severity="warning" className="ml-4" rounded onClick={exportPdf} data-pr-tooltip="PDF" />
      </>

    )
  }

  const gotoPreventivo = (prev) => {
   
    setDettPreventivo(prev)
    setDettPreventivoVisible(true)
  }

  const statoRowFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={stati}
        onChange={(e) => options.filterApplyCallback(e.value)}
        optionLabel="label"
        optionValue="value"
        placeholder="Seleziona"
        className="p-column-filter"
        maxSelectedLabels={1}
        style={{ minWidth: '14rem' }}
      />
    );
  };

  const formatDate = (value) => {
    return value?.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const handleCambiaStato = (preventivo, valore) => {
    preventivo.stato = valore
    axios.post('https://backend.mnediliziaristrutturazione.com/cambiastatopreventivo', preventivo, { headers: { "pwd": passwordInserita } })
      .then(() => {
        fetchData()
        showToast({
          severity: "success",
          summary: "Cambio stato effettuato",
          detail: "Il cambio stato del preventivo è stato effettuato",
          life: 3000,
        });
      })
      .catch(error => {
        showToast({
          severity: "error",
          summary: "ERRORE",
          detail: "Errore cambio di stato",
          life: 3000,
        });
      })
  }

  const cols = [
    { field: 'id', header: 'ID' },
    { field: 'nome', header: 'Nome' },
    { field: 'dataInserimento', header: 'Data' },
    { field: 'mail', header: 'Email' },
    { field: 'tel', header: 'Telefono' },
    { field: 'stato', header: 'Stato' }
  ];

  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));

  const exportPdf = () => {
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then(() => {
        const doc = new jsPDF.default(0, 0);
        const _preventiviPDf = [...preventivi].map(preventivo => {
          preventivo.dataInserimento = moment(preventivo.dataInserimento).format("DD/MM/YYYY");
          return preventivo
        })
        doc.autoTable(exportColumns, _preventiviPDf);
        doc.save('ElencoPreventivi.pdf');
      });
    });
  };

  const statoBodyTemplate = (rowData) => {

    return (<>
      <Dropdown value={rowData.stato}
        onChange={(e) => handleCambiaStato(rowData, e.value)}
        options={stati}
        optionLabel="label"
        optionValue="value"
        //itemTemplate={statoItemBodyTemplate}
        //placeholder="Select a City" 
        className="w-full md:w-14rem" />
    </>)
    //return moment(rowData.dataInserimento).format("DD/MM/YYYY");
  };

  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.dataInserimento);
    //return moment(rowData.dataInserimento).format("DD/MM/YYYY");
  }

  const dateFilterTemplate = (options) => {
  return(
    <Calendar value={options.value}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      dateFormat="dd/mm/yyyy" placeholder="dd/MM/yyyy"  />
    )
  }

  const handleGeneratePdf = () => {
    
    axios.post('https://backend.mnediliziaristrutturazione.com/preventivoPdf',
      { 
        "id": dettPreventivo.id,
        "preventivo": prevTab,
        "infoUtente": {
          "nome": dettPreventivo.nome,
          "email": dettPreventivo.mail,
          "tel": dettPreventivo.tel
        },
        "preventivoJson": preventivo,
        "extraTab": extraTab }
        , {headers: { "pwd": passwordInserita } })
      .then((response) => { 
        const {pdfBase64 , fileName} = response.data;
        // Convert base64 string to Blob
        const byteCharacters = atob(pdfBase64.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Create a link element and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error(error));
  }

  const handleMailTo = () => {
    window.location.href = 'mailto:' + dettPreventivo.mail + '?subject=[M&N edilizia e ristrutturazioni - preventivo Nr. ' + dettPreventivo.id + ']';
  }

  const handleInviaPreventivoCliente = () =>{
    debugger
          axios.post('https://backend.mnediliziaristrutturazione.com/inviapreventivo',
              { "preventivo": prevTab, dettPreventivo:dettPreventivo,   "preventivoJson": preventivo, "extraTab": extraTab })
              .then(() => {

                  showToast({
                      severity: "success",
                      summary: "Inviato",
                      detail: "Preventivo inviato al cliente con successo",
                      life: 3000,
                  });
              })
              .catch(error => {
                  showToast({
                      severity: "error",
                      summary: "ERRORE",
                      detail: "Errore nell'invio del preventivo",
                      life: 3000,
                  });
              })

  }

  
  const commandTemplate = () => {
    return (
      <div className='flex gap-3'>
        {/*<div className=''>
          <Button icon="pi pi-file-pdf" label="Salva PDF" aria-label="pdf" onClick={()=>handleGeneratePdf} type="button"></Button>
        </div>*/}
        <div className=''>
          <Button onClick={()=>handleInviaPreventivoCliente()} label='Invia preventivo al cliente' icon="pi pi-pencil" type='button' />
        </div>
      </div>
    )
  }

  const handleResults = (_preventivo, _prevTab, _extraTab) => {
    if (JSON.stringify(_preventivo) !== JSON.stringify(preventivo)) {
    setPreventivo(_preventivo)
    setPrevTab(_prevTab)
    setExtraTab(_extraTab)
    }
  }

const handleChangePrev = (prev) => {
  setDettPreventivo({...dettPreventivo, ["preventivoJson"] : JSON.stringify(prev)})
}

  return (
    <div className="px-3 py-2">
      {dettPreventivo && dettPreventivoVisible &&
        <Dialog 
          id="preventivoDialog"
          visible={dettPreventivoVisible}
          header={`Dettaglio preventivo Nr. ${dettPreventivo.id}`}
          blockScroll={true}
          className="w-9"
          onHide={() => {
            setDettPreventivoVisible(false)
            setDettPreventivo(null)
          } }>
          <h2>Cliente: <span className="font-normal">{dettPreventivo.nome}</span></h2>
          <Preventivo 
            onChangePrev={handleChangePrev}
            abilitaModifica={true}
            preventivo={JSON.parse(dettPreventivo.preventivoJson)}
            commandTemplate={commandTemplate()}
            onCalculate={(a,b,c)=>handleResults(a,b,c)}>
          </Preventivo>
        </Dialog>
      }
      <BlockUI blocked={loading} fullScreen template={<i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }}></i>}></BlockUI>
      {!passwordInserita ? (
        loginJsx
      ) : (
        <>
          <Toolbar className="mb-4" start={renderHeader} />
          <DataTable
            paginator
            rows={20}
            rowGroupMode="rowspan"
            groupRowsBy="nome"
            sortMode="multiple" 
            sortField="nome" 
            sortOrder={1}
            //header={header} 
            filters={filters} 
            filterDisplay="row"
            globalFilterFields={['id', 'dataInserimento', 'stato', 'tel', 'nome', 'mail']}
            onFilter={(e) => setFilters(e.filters)}
            //selection={selectedCustomer} onSelectionChange={(e) => setSelectedCustomer(e.value)} selectionMode="single" 
            dataKey="id"
            emptyMessage="Nessun preventivo trovato"
            value={preventivi}
            size={"small"}>

            <Column
              field="nome"
              header="Nome"
              sortable
              filter
              showFilterMenu={false}
              align={"left"}
              style={{ minWidth: "200px" }}
            ></Column>
            <Column
              field="mail"
              header="Mail"
              sortable
              filter
              showFilterMenu={false}
              align={"left"}
              style={{ minWidth: "200px" }}
            ></Column>
            <Column
              field="id"
              header="Preventivo Id"
              sortable
              filter
              showFilterMenu={false}
              align={"left"}
              style={{ minWidth: "200px" }}
            ></Column>
            <Column
              field="dataInserimento"
              header="Data Preventivo"
              sortable
              //filter
              showFilterMenu={false}
              //filterField="dataInserimento"
              dataType="date"
              align={"left"}
              style={{ minWidth: "200px" }}
              body={dateBodyTemplate}
              //filterElement={dateFilterTemplate}
            ></Column>
            <Column
              field="stato"
              header="Stato"
              sortable
              filter
              filterField="stato"
              body={statoBodyTemplate}
              showFilterMenu={false}
              filterMenuStyle={{ width: '14rem' }}
              filterElement={statoRowFilterTemplate}
              align={"left"}
              style={{ minWidth: "200px" }}
            ></Column>


            <Column
              field="tel"
              header="Telefono"
              sortable
              filter
              showFilterMenu={false}
              align={"left"}
              style={{ minWidth: "200px" }}
            ></Column>


            <Column
              header="Preventivo"
              align={"center"}
              style={{ minWidth: "200px" }}
              body={(item) => {
                return (<>
                  <Button label="Visualizza" rounded icon="pi pi-detail" onClick={() => gotoPreventivo(item)}></Button>
                </>)
              }}
            ></Column>
          </DataTable>
        </>
      )}
    </div>
  );
};

export default ListaPreventiviPage;
